// @ts-nocheck
(function() {
  var $ = window.jQuery;
  if (!$) {
    console.warn('jQuery not found — Slick requires jQuery.');
    return;
  }

  function initSlick($container) {
    if ($container.hasClass('slick-initialized')) return;

    $container.slick({
      centerMode: true,
      centerPadding: '0',
      slidesToShow: 1,
      dots: true,
      variableWidth: true,
      accessibility: false,
      infinite: true,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 2000
    });
  }

  // Wait until all images in this container are loaded
  function waitForImages($container, callback) {
    var $imgs = $container.find('img');
    var total = $imgs.length;
    if (total === 0) {
      callback();
      return;
    }

    var count = 0;
    $imgs.each(function() {
      if (this.complete) {
        count++;
        if (count === total) callback();
      } else {
        $(this).one('load error', function() {
          count++;
          if (count === total) callback();
        });
      }
    });
  }

  $(function() {
    $('.image-slider').each(function() {
      var $this = $(this);
      waitForImages($this, function() {
        initSlick($this);
      });
    });
  });

  // Re-init when Shopify reloads a section
  $(document).on('shopify:section:load shopify:section:reorder', function() {
    $('.image-slider').each(function() {
      var $this = $(this);
      if ($this.hasClass('slick-initialized')) {
        $this.slick('unslick');
      }
      waitForImages($this, function() {
        initSlick($this);
      });
    });
  });

})();
